import { useMemo } from 'react'

import { useApolloClient } from '@apollo/client'
import { InFilterDefinition } from '@factorialco/f0-react'
import * as Sentry from '@sentry/browser'
import { CurrencyExpenseFilterDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const FILTER_LABEL = 'currency'

export const useCurrencyFilter = (): InFilterDefinition<string> => {
  const apolloClient = useApolloClient()

  return useMemo(
    () => ({
      label: i18n.t('expenses_v2.list.header.currency'),
      type: 'in' as const,
      options: {
        cache: true,
        options: async () => {
          try {
            const result = await apolloClient.query({
              query: CurrencyExpenseFilterDocument,
              fetchPolicy: 'cache-first',
            })

            const edges = result.data?.apiCore?.currenciesConnection?.edges ?? []
            return edges.map((edge) => ({
              label: `${edge.node.isoCode} - ${edge.node.name}`,
              value: edge.node.isoCode,
            }))
          } catch (error) {
            Sentry.captureException(error, {
              tags: { component: 'expenses' },
              extra: { filter: FILTER_LABEL },
            })
            return []
          }
        },
      },
    }),
    [apolloClient]
  )
}
